function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindDirectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_x32_",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      width: 32,
      height: 32,
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g837",
    transform: "rotate(180,256.00046,256.0006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 476.811,492.379 268.639,8.332 c -2.172,-5.047 -7.141,-8.328 -12.641,-8.328 -5.5,0 -10.469,3.281 -12.641,8.328 L 35.186,492.379 c -2.656,5.625 -1.203,12.344 3.547,16.359 4.766,4.016 11.625,4.359 16.734,0.813 L 255.998,370.519 456.545,509.551 c 5.109,3.547 11.969,3.203 16.734,-0.813 4.75,-4.015 6.188,-10.734 3.532,-16.359 z",
    style: {
      fill: "#ffffff"
    },
    id: "path835",
    "inkscapeConnector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindDirectionArrow);
export default __webpack_public_path__ + "static/media/wind-direction-arrow.78b994173ff9ba46e9c9964032a2ad21.svg";
export { ForwardRef as ReactComponent };